import type { ReportContext as Context } from '@lixionary-jira/domain';
import { Field, Input, Textarea } from '../../ui/forms';

export function ReportContextFields({
  value,
  onChange,
}: {
  value: Context;
  onChange: (value: Context) => void;
}) {
  return (
    <>
      <Field label="Screen name" optional>
        {(p) => (
          <Input
            {...p}
            maxLength={200}
            value={value.screenName ?? ''}
            onChange={(e) => onChange({ ...value, screenName: e.target.value })}
          />
        )}
      </Field>
      <Field label="Screen URL" optional hint="The page where this happened.">
        {(p) => (
          <Input
            {...p}
            type="url"
            maxLength={2048}
            value={value.screenUrl ?? ''}
            onChange={(e) => onChange({ ...value, screenUrl: e.target.value })}
          />
        )}
      </Field>
      <Field
        label="Example data"
        optional
        hint="Record IDs, sample values, JSON, or an explanation of the affected data."
      >
        {(p) => (
          <Textarea
            {...p}
            rows={5}
            maxLength={20000}
            value={value.exampleData ?? ''}
            onChange={(e) => onChange({ ...value, exampleData: e.target.value })}
          />
        )}
      </Field>
    </>
  );
}

export function ReportContextDisplay({ value }: { value: Context }) {
  if (!value.screenName && !value.screenUrl && !value.exampleData) return null;
  return (
    <section className="stack sm" aria-label="Report context">
      <h3>Report context</h3>
      {value.screenName && (
        <p>
          <strong>Screen:</strong> {value.screenName}
        </p>
      )}
      {value.screenUrl && (
        <a href={value.screenUrl} target="_blank" rel="noopener noreferrer">
          {value.screenUrl}
        </a>
      )}
      {value.exampleData && (
        <>
          <strong className="small">Example data</strong>
          <pre style={{ whiteSpace: 'pre-wrap', overflowWrap: 'anywhere' }}>{value.exampleData}</pre>
        </>
      )}
    </section>
  );
}
